import React from "react";
import { Link } from "react-router-dom";
import { FaSearch, FaCogs, FaLink, FaChartLine } from "react-icons/fa";
import SEO from '../../components/SEO';


const green = "#8cc540";

export default function SEOPage() {
  return (
      <>
    <SEO title="Search Engine Optimization" />
    <div className="w-full">
      {/* Hero Section */}
      <div className="bg-[#8cc540] py-16 text-white text-center px-4">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Search Engine Optimisation (SEO)</h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto">
          Improve your website’s visibility, rank higher on Google, and grow your organic traffic with our proven SEO strategies.
        </p>
      </div>

      {/* Overview Section */}
      <div className="py-12 px-4 sm:px-8 max-w-5xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-[#0a3c6d] mb-6">What is SEO?</h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          SEO (Search Engine Optimisation) is the process of optimizing your website to rank higher on search engines like Google, Bing, and Yahoo. A well-optimized site gains more visibility, traffic, and credibility—without paid ads.
        </p>
      </div>

      {/* Key SEO Services */}
      <div className="bg-gray-50 py-12 px-4 sm:px-8">
        <h2 className="text-2xl md:text-3xl font-semibold text-center text-[#0a3c6d] mb-10">Our Core SEO Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Service Card */}
          <div className="bg-white rounded-lg shadow p-6 text-center border-t-4 border-[#8cc540]">
            <FaCogs className="text-4xl mx-auto text-[#8cc540] mb-4" />
            <h3 className="text-xl font-semibold mb-2">Technical SEO</h3>
            <p className="text-gray-600">
              We ensure your website is crawlable, fast, mobile-friendly, and technically optimized for search engines.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow p-6 text-center border-t-4 border-[#8cc540]">
            <FaSearch className="text-4xl mx-auto text-[#8cc540] mb-4" />
            <h3 className="text-xl font-semibold mb-2">On-Page SEO</h3>
            <p className="text-gray-600">
              Optimize content, titles, meta tags, and internal linking for better rankings and user experience.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow p-6 text-center border-t-4 border-[#8cc540]">
            <FaLink className="text-4xl mx-auto text-[#8cc540] mb-4" />
            <h3 className="text-xl font-semibold mb-2">Off-Page SEO</h3>
            <p className="text-gray-600">
              Build high-quality backlinks and domain authority through ethical outreach and content strategies.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow p-6 text-center border-t-4 border-[#8cc540]">
            <FaChartLine className="text-4xl mx-auto text-[#8cc540] mb-4" />
            <h3 className="text-xl font-semibold mb-2">SEO Analytics</h3>
            <p className="text-gray-600">
              Track performance with tools like Google Analytics, Search Console, and monthly reports.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-[#0a3c6d] py-12 text-white text-center">
        <h2 className="text-3xl font-bold mb-3">Start Ranking Higher Today</h2>
        <p className="text-lg mb-6">
          Let our SEO experts boost your website's visibility and bring in consistent organic traffic.
        </p>
        <Link
          to="/contact-us"
          className="inline-block px-6 py-3 bg-[#8cc540] text-white font-medium rounded hover:bg-[#7aaa3f] transition"
        >
          Contact Us for SEO
        </Link>
      </div>
</div>
</>      
  );
}
